import "./spinner1.css";

const Spinner1 = ({ className }: { className?: string }) => {
    return (
        <svg className={`spinner1 ${className}`} viewBox="0 0 50 50">
            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
        </svg>
    );
};

export default Spinner1;
